// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CommentRepliesInner
 */
export interface CommentRepliesInner {
    /**
     * 
     * @type {string}
     * @memberof CommentRepliesInner
     */
    author: string;
    /**
     * 
     * @type {string}
     * @memberof CommentRepliesInner
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof CommentRepliesInner
     */
    timestamp: string;
}

/**
 * Check if a given object implements the CommentRepliesInner interface.
 */
export function instanceOfCommentRepliesInner(value: object): value is CommentRepliesInner {
    if (!('author' in value) || value['author'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    return true;
}

export function CommentRepliesInnerFromJSON(json: any): CommentRepliesInner {
    return CommentRepliesInnerFromJSONTyped(json, false);
}

export function CommentRepliesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommentRepliesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'author': json['author'],
        'text': json['text'],
        'timestamp': json['timestamp'],
    };
}

export function CommentRepliesInnerToJSON(json: any): CommentRepliesInner {
    return CommentRepliesInnerToJSONTyped(json, false);
}

export function CommentRepliesInnerToJSONTyped(value?: CommentRepliesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'author': value['author'],
        'text': value['text'],
        'timestamp': value['timestamp'],
    };
}
